import { Section } from "../tools/section";
import { AccordionSlide, SELECTOR_SUMMARY } from "../objects/AccordionSlide";
import { updateAsideMediaAnimation } from "../animations/sections/image-and-text-columns";

// Selectors
export const SELECTOR_SECTION = '[data-image-and-text-columns]';
const SELECTOR_ACCORDION_CONTAINER = '[data-accordion-container]';
const SELECTOR_ACCORDION_SLIDE = '[data-accordion-slide]';

export class ImageAndTextColumns extends Section {
  private accordionContainer: HTMLElement | null = null;
  private accordionSlideElements: HTMLDetailsElement[] = [];
  private accordionSlides: AccordionSlide[] = [];

  queryChildren(container: HTMLElement) {
    this.accordionContainer = container.querySelector(SELECTOR_ACCORDION_CONTAINER);
    if (this.accordionContainer) {
      this.accordionSlideElements = Array.from(
        this.accordionContainer.querySelectorAll<HTMLDetailsElement>(SELECTOR_ACCORDION_SLIDE)
      );
    }
  }

  attachEvents() {
    if (!this.accordionSlideElements || this.accordionSlideElements.length === 0) return;

    // Initialize AccordionSlide instances for smooth animations
    this.accordionSlideElements.forEach((slideElement, index) => {
      const newSlide = new AccordionSlide(slideElement);
      this.accordionSlides.push(newSlide);

      const slideSummary = slideElement.querySelector<HTMLElement>(SELECTOR_SUMMARY);
      if (slideSummary) {
        slideSummary.addEventListener('click', (e) => this.onAccordionClick(e, index));
      }
    });
  }

  detatchEvents(): void {
    if (!this.accordionSlideElements || this.accordionSlideElements.length === 0) return;

    this.accordionSlideElements.forEach((slideElement) => {
      const slideSummary = slideElement.querySelector<HTMLElement>(SELECTOR_SUMMARY);
      if (slideSummary) {
        slideSummary.removeEventListener('click', (e) => this.onAccordionClick(e, -1));
      }
    });
  }

  private onAccordionClick(e: Event, clickedIndex: number) {
    if (!this.accordionSlides || this.accordionSlides.length === 0) return;

    const clickedSlide = this.accordionSlides[clickedIndex];
    if (!clickedSlide) return;

    // Close all other accordions with animation
    this.accordionSlides.forEach((slide, index) => {
      if (index !== clickedIndex && slide.el.open) {
        slide.onClick(e);
      }
    });

    // Trigger the clicked accordion animation
    clickedSlide.onClick(e);

    // Update aside media animation and refresh ScrollTrigger after accordion animation completes
    setTimeout(() => {
      // Update aside media animation based on new accordion states
      if (this.container) {
        updateAsideMediaAnimation(this.container);
      }
      
      // Refresh all ScrollTriggers
      if (typeof window !== 'undefined' && (window as any).ScrollTrigger) {
        (window as any).ScrollTrigger.refresh();
      }
    }, 450); // Wait for accordion animation (400ms) to complete
  }
}

Section.register(SELECTOR_SECTION, ImageAndTextColumns);
